
export const retrieveBorderColor = (n, d, com) =>{
	const pc = 100 * (n[com] - d[com]) / d[com];

	let borderColor;

	if (pc < 0){
		borderColor = '#34CF5D';
		return borderColor;
	} else if(pc > 0){
		borderColor = '#FF6663';
		return borderColor;
	}
	else if (pc === 0){
		borderColor = '#FFFFFF';
		return borderColor;
	}
};

